import createReactComponent from '../createReactComponent';
export default createReactComponent('dots', 'Dots', [["path",{"d":"M12 12.25v-.5m4 .5v-.5m-8 .5v-.5","key":"svg-0"}]]);